<template>
  <section class="d-grid gap-1 sponser px-0">
    <h3
      v-if="showDifferentTitle.length"
      class="service has-text-centered is-size-3"
    >
      {{ $t(showDifferentTitle) }}
    </h3>
    <h3
      v-else
      class="is-narrow is-size-4 has-text-black has-text-weight-bold pl-0"
    >
      {{ $t('topEmployers') }}
    </h3>
    <div class="slider">
      <div class="slide-track">
        <div v-for="img in employers" :key="img.id" class="slide">
          <img
            class="lift-shadow pa-4"
            :src="img.src"
            :alt="img.alt"
            height="100"
            width="250"
          />
        </div>
      </div>
    </div>
    <div class="slider">
      <div class="slide-track2">
        <div v-for="img in employers2" :key="img.id" class="slide">
          <img
            class="lift-shadow pa-4"
            :src="img.src"
            :alt="img.alt"
            height="100"
            width="250"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    showDifferentTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      employers: [
        {
          id: 1,
          src: '/images/account/ambasdor_logo.jpg',
          alt: 'kitchen'
        },

        {
          id: 2,
          src: '/images/account/hydrebadi_dum.jpg',
          alt: 'hulas'
        },

        {
          id: 3,
          src: '/images/account/bajeko_sekuwa.jpg',
          alt: 'bajeko'
        },

        {
          id: 4,
          src: '/images/account/golden_gate.jpg',
          alt: 'websurfer'
        },

        { id: 5, src: '/images/account/goyal_logo.jpg', alt: 'lotus' },

        {
          id: 6,
          src: '/images/account/filli_cafe.jpg',
          alt: 'healthcare'
        },

        {
          id: 7,
          src: '/images/account/grand_norling.jpg',
          alt: 'zuleika'
        },

        { id: 8, src: '/images/account/haadi_logo.jpg', alt: 'hotel' },
        { id: 9, src: '/images/account/java_logo.jpg', alt: 'hotel' },

        { id: 10, src: '/images/account/mt_everest.jpg', alt: 'hotel' },
        {
          id: 11,
          src: '/images/account/level_three.jpg',
          alt: 'hotel'
        },

        { id: 12, src: '/images/account/jump_ktm.jpg', alt: 'hotel' },
        { id: 13, src: '/images/account/mugal_logo.jpg', alt: 'hotel' },
        {
          id: 14,
          src: '/images/account/paradise_hill.jpg',
          alt: 'hotel'
        },
        {
          id: 15,
          src: '/images/account/hotel_himalaya.jpg',
          alt: 'hotel'
        },
        {
          id: 16,
          src: '/images/account/jampa.jpg',
          alt: 'hotel'
        },
        {
          id: 17,
          src: '/images/account/jandt_associates.jpg',
          alt: 'hotel'
        },
        {
          id: 18,
          src: '/images/account/kh.jpg',
          alt: 'hotel'
        },
        {
          id: 19,
          src: '/images/account/kucho.jpg',
          alt: 'hotel'
        },
        {
          id: 20,
          src: '/images/account/kyampa.jpg',
          alt: 'hotel'
        },
        {
          id: 21,
          src: '/images/account/nd.jpg',
          alt: 'hotel'
        },
        {
          id: 22,
          src: '/images/account/newa_rockyard.jpg',
          alt: 'hotel'
        },
        {
          id: 23,
          src: '/images/account/nova.jpg',
          alt: 'hotel'
        },
        {
          id: 24,
          src: '/images/account/oriental_kitchen.jpg',
          alt: 'hotel'
        },
        {
          id: 25,
          src: '/images/account/parzada.jpg',
          alt: 'hotel'
        },
        {
          id: 26,
          src: '/images/account/world_link.jpg',
          alt: 'hotel'
        },
        {
          id: 27,
          src: '/images/account/tranquility_spa.png',
          alt: 'spa'
        }
      ],
      employers2: [
        {
          id: 1,
          src: '/images/account/rato_bangla.jpg',
          alt: 'hotel'
        },
        {
          id: 2,
          src: '/images/account/sarawagi_group.jpg',
          alt: 'hotel'
        },
        {
          id: 3,
          src: '/images/account/shangrilla_hotel.jpg',
          alt: 'hotel'
        },
        {
          id: 4,
          src: '/images/account/tukuche_thakali.jpg',
          alt: 'hotel'
        },
        { id: 5, src: '/images/account/tag_logo.jpg', alt: 'hotel' },
        {
          id: 6,
          src: '/images/account/united_school.jpg',
          alt: 'hotel'
        },
        { id: 7, src: '/images/account/dekhaido.jpg', alt: 'hotel' },
        { id: 8, src: '/images/account/alpha_beta.jpg', alt: 'hotel' },
        { id: 9, src: '/images/account/bhola_foods.jpg', alt: 'hotel' },
        { id: 10, src: '/images/account/biryani_adda.jpg', alt: 'hotel' },
        { id: 11, src: '/images/account/classy_printing.jpg', alt: 'hotel' },
        { id: 12, src: '/images/account/cotton_mill.jpg', alt: 'hotel' },
        { id: 13, src: '/images/account/dal_bhat.jpg', alt: 'hotel' },
        { id: 14, src: '/images/account/east_west_college.jpg', alt: 'hotel' },
        { id: 15, src: '/images/account/EE.jpg', alt: 'hotel' },
        { id: 16, src: '/images/account/el_maven.jpg', alt: 'hotel' },
        { id: 17, src: '/images/account/garuda.jpg', alt: 'hotel' },
        { id: 18, src: '/images/account/gem_plasticware.jpg', alt: 'hotel' },
        { id: 19, src: '/images/account/hafner.jpg', alt: 'hotel' },
        { id: 20, src: '/images/account/himalaya_institute.jpg', alt: 'hotel' },
        {
          id: 21,
          src: '/images/account/pretty_click.jpg',
          alt: 'hotel'
        },
        {
          id: 22,
          src: '/images/account/sabkura.jpg',
          alt: 'hotel'
        },
        {
          id: 23,
          src: '/images/account/samsara.jpg',
          alt: 'hotel'
        },
        {
          id: 24,
          src: '/images/account/the_soaltee.jpg',
          alt: 'hotel'
        },
        {
          id: 26,
          src: '/images/account/tukutuku_logo.jpg',
          alt: 'hotel'
        },
        {
          id: 27,
          src: '/images/account/tibsa.png',
          alt: 'spa'
        }
      ]
    }
  },
  mounted() {
    this.duplicateImages()
  },
  methods: {
    duplicateImages() {
      const slideTrack = document.querySelector('.slide-track')
      const slideTrack2 = document.querySelector('.slide-track2')
      const imagesCount = this.employers.length
      const imagesCount2 = this.employers2.length

      for (let i = 0; i < imagesCount * 2; i++) {
        const imageIndex = i % imagesCount
        const clonedImage = slideTrack.children[imageIndex].cloneNode(true)
        slideTrack.appendChild(clonedImage)
      }
      for (let i = 0; i < imagesCount2 * 2; i++) {
        const imageIndex = i % imagesCount2
        const clonedImage = slideTrack2.children[imageIndex].cloneNode(true)
        slideTrack2.appendChild(clonedImage)
      }
    }
  }
}
</script>

<style>
.d-grid {
  display: grid;
}
.sponser {
  max-width: 84.375rem;
  width: 100%;
  margin: auto;
}
.service-image {
  grid-template-columns: repeat(9, 1fr);
  grid-auto-rows: 6rem;
}
.service-image img {
  background: #ffffff;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  object-fit: contain;
}
@media screen and (max-width: 760px) {
  .service-image {
    grid-template-columns: repeat(2, 1fr);
    padding-top: 0;
  }
  .service-image img {
    width: 100%;
  }
}
.service h3 {
  line-height: 37px;
}
.lift-shadow {
  transition: 0.5s;
}
.lift-shadow:hover {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.16);
  transform: scale(1.02);
}
.slider {
  height: 6rem;
  margin: auto;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.slide-track {
  animation: scroll 40s linear infinite;
  display: flex;
  width: calc(450px * 14);
}

.slide-track2 {
  animation: right 40s linear infinite;
  display: flex;
  width: calc(450px * 14);
}

.slide {
  height: 2rem;
  width: 7rem;
}

@keyframes right {
  100% {
    transform: translateX(0);
  }
  0% {
    transform: translateX(calc(-250px * 7));
  }
}
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-250px * 7));
  }
}
</style>
